import { useEffect, useState } from 'react'
import { useCookieConsentContext } from './CookieConsentContext'
import { gtag } from 'src/shared/js/external/gtag'
import { useFlags } from 'launchdarkly-react-client-sdk'

declare global {
  interface Window {
    gtag: gtag | undefined
  }
}

// This needs to have a mixed consent logic for ads and analytics
// ads_ prefix is for Google Ads, analytics_ prefix is for Google Analytics. We need to handle this properly

export const GoogleTagConsentHandler = () => {
  const { ethycaInitialized, analyticsConsent, marketingConsent } =
    useCookieConsentContext()
  const { ooEthycaAds, ooGtmConsentDefaultDeny } = useFlags()
  const [gtagInitialized, setGtagInitialized] = useState(false)

  const handleGtagInitialized = () => {
    setGtagInitialized(true)
  }

  // The HTML shell defines window.gtag synchronously, so there is nothing to wait for.
  useEffect(() => {
    if (ooGtmConsentDefaultDeny) {
      return
    }
    if (!window.gtag) {
      window.addEventListener('gtag_initialized', handleGtagInitialized)
    }
    return () => {
      window.removeEventListener('gtag_initialized', handleGtagInitialized)
    }
  }, [ooGtmConsentDefaultDeny])

  useEffect(() => {
    if (!ethycaInitialized || !window.gtag) {
      return
    }

    // FF Gating whether we use the new broken down Gtag consent model for Ads.
    if (ooEthycaAds ?? false) {
      // Update analytics consent
      if (analyticsConsent) {
        window.gtag('consent', 'update', {
          analytics_storage: 'granted'
        })
      } else {
        window.gtag('consent', 'update', {
          analytics_storage: 'denied'
        })
      }

      // Update marketing/ad consent
      if (marketingConsent) {
        window.gtag('consent', 'update', {
          ad_storage: 'granted',
          ad_user_data: 'granted',
          ad_personalization: 'granted'
        })
      } else {
        window.gtag('consent', 'update', {
          ad_storage: 'denied',
          ad_user_data: 'denied',
          ad_personalization: 'denied'
        })
      }
    } else {
      if (analyticsConsent) {
        window.gtag('consent', 'update', {
          analytics_storage: 'granted',
          ad_storage: 'granted',
          ad_user_data: 'granted',
          ad_personalization: 'granted'
        })
      } else {
        window.gtag('consent', 'update', {
          ad_storage: 'denied',
          ad_user_data: 'denied',
          ad_personalization: 'denied',
          analytics_storage: 'denied'
        })
      }
    }
  }, [ethycaInitialized, analyticsConsent, marketingConsent, gtagInitialized])
  return null
}
